import { render, staticRenderFns } from "./CountedServiceTransactionInfo.vue?vue&type=template&id=b42672fc&"
import script from "./CountedServiceTransactionInfo.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTransactionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports